import {FC} from 'react'
import {useLang} from './Metronici18n'
import {IntlProvider} from 'react-intl'
import '@formatjs/intl-relativetimeformat/polyfill'
import '@formatjs/intl-relativetimeformat/locale-data/en'
import '@formatjs/intl-relativetimeformat/locale-data/de'
import '@formatjs/intl-relativetimeformat/locale-data/bs-Latn'
import '@formatjs/intl-relativetimeformat/locale-data/hr'
import '@formatjs/intl-relativetimeformat/locale-data/sr-Latn'

import deMessages from './messages/de.json'
import enMessages from './messages/en.json'
import bsMessages from './messages/bs.json'
import hrMessages from './messages/bs.json'
import srMessages from './messages/bs.json'

const allMessages = {
  de: deMessages,
  en: enMessages,
  bs: bsMessages,
  hr: hrMessages,
  sr: srMessages,
}

const I18nProvider: FC = ({children}) => {
  const locale = useLang()
  const messages = allMessages[locale]

  return (
    <IntlProvider locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  )
}

export {I18nProvider}
